import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddBorderIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 400 356",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".add-border-icon-cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:28px;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "add-border-icon-cls-1",
			d: "m205.21,22.57h108.3c13.81,0,25,11.19,25,25v84.85"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "add-border-icon-cls-1",
			d: "m19.49,132.42V47.57c0-13.81,11.19-25,25-25h109.11"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "add-border-icon-cls-1",
			d: "m153.61,293.84H44.49c-13.81,0-25-11.19-25-25v-84.92"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "add-border-icon-cls-1",
			x1: 222.21,
			y1: 267.28,
			x2: 394.51,
			y2: 267.28
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "add-border-icon-cls-1",
			x1: 308.36,
			y1: 181.13,
			x2: 308.36,
			y2: 353.43
		})
	]
});
export default SvgAddBorderIcon;
